import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $ArticleCommentDetail } from 'shared/atoms/article/article-comment-detail';
import { IPrimaryComment } from 'shared/models';
import { CommentItem } from '@article/body/comment/comment-item';
import { RepliesSeeMore } from '@article/body/comment/replies-see-more';

interface ICommentReplyListProps {
  comment: IPrimaryComment;
}

export const CommentReplyList: FC<ICommentReplyListProps> = (props) => {
  const { comment } = props;
  const { commentId } = comment;
  const { replies } = useAtomValue($ArticleCommentDetail(commentId));

  return (
    <div className="comment-reply-list">
      {replies.map((reply) => (
        <CommentItem comment={reply} key={reply.commentId} />
      ))}
      <RepliesSeeMore comment={comment} />
    </div>
  );
};
